// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team {
  background: white;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-top: 60px;
}

.team-member {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  text-align: center;
}

.team-member:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(158, 37, 54, 0.15);
  border-color: #9e2536;
}

.member-avatar {
  width: 140px;
  height: 140px;
  margin: 0 auto 24px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(158, 37, 54, 0.3);
  border: 4px solid #9e2536;
  position: relative;
  background: #9e2536;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 20%;
  display: block;
}

.member-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.member-role {
  font-size: 1rem;
  color: #9e2536;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.member-university {
  font-size: 0.9rem;
  color: #718096;
  font-weight: 500;
  margin-bottom: 16px;
  font-style: italic;
}

.member-description {
  color: #4a5568;
  line-height: 1.6;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .team-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .team-member {
    padding: 30px 20px;
  }
  
  .member-avatar {
    width: 120px;
    height: 120px;
  }
  
  .member-name {
    font-size: 1.3rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Team.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".team {\n  background: white;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 40px;\n  margin-top: 60px;\n}\n\n.team-member {\n  background: white;\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 1px solid #f0f0f0;\n  text-align: center;\n}\n\n.team-member:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 40px rgba(158, 37, 54, 0.15);\n  border-color: #9e2536;\n}\n\n.member-avatar {\n  width: 140px;\n  height: 140px;\n  margin: 0 auto 24px;\n  border-radius: 50%;\n  overflow: hidden;\n  box-shadow: 0 10px 20px rgba(158, 37, 54, 0.3);\n  border: 4px solid #9e2536;\n  position: relative;\n  background: #9e2536;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 20%;\n  display: block;\n}\n\n.member-name {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.member-role {\n  font-size: 1rem;\n  color: #9e2536;\n  font-weight: 500;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.member-university {\n  font-size: 0.9rem;\n  color: #718096;\n  font-weight: 500;\n  margin-bottom: 16px;\n  font-style: italic;\n}\n\n.member-description {\n  color: #4a5568;\n  line-height: 1.6;\n  font-size: 0.95rem;\n}\n\n@media (max-width: 768px) {\n  .team-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n  \n  .team-member {\n    padding: 30px 20px;\n  }\n  \n  .member-avatar {\n    width: 120px;\n    height: 120px;\n  }\n  \n  .member-name {\n    font-size: 1.3rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
